import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SolardashboardService } from 'src/app/services/solardashboard.service';
import Swal from 'sweetalert2';
import { SolarManagerComponent } from '../solar-manager.component';

@Component({
  selector: 'app-addupdatesolarmanager',
  templateUrl: './addupdatesolarmanager.component.html',
  styleUrls: ['./addupdatesolarmanager.component.scss']
})
export class AddupdatesolarmanagerComponent implements OnInit {
  descriptionForm: FormGroup;
  parameters: FormGroup;
  alertParameter: FormGroup;
  altertNotification: FormGroup;
  dtmuDevice: FormGroup;
  formData:any= {};
  deviceMaster: any;
  frequencyMsg: any = {};
  frequencyError: any;
  action: string;
  Frequency = ['Minutes','Days','Hours'];
  currentUserData = JSON.parse(localStorage.getItem('userData'))
  roleID = this.currentUserData.roleid;
  imageTouched = false;
  imageRequiredError = false;
  constructor(private formBuilder:FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any,private solarService:SolardashboardService,private matDialogRef:MatDialogRef<SolarManagerComponent>) { }

  ngOnInit() {
    console.log("what is coming",this.data);
    this.deviceMaster = this.data.deviceMaster;
    this.action = this.data.action.toLowerCase();
  
    this.createForm();
  }
  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.descriptionForm.patchValue({ image: file });
      const imageControl = this.descriptionForm.get('image');
      if (imageControl) {
        imageControl.markAsTouched();
      }    }
  }

createForm(){
    this.descriptionForm = this.formBuilder.group({
      'make_by': [null, [Validators.required]],
      'serialNo': [null, [Validators.required]],
      'asset_name':[null, [Validators.required]],
      'manufacturing_date': [null, [Validators.required]],
      'installation_date': [null, [Validators.required]],
      'capacity_kw': [null, [Validators.required]],
      'panel_type': [null, [Validators.required]],
      'facing_direction':[null, [Validators.required]],
      'tilt_angle':[null, [Validators.required]],
      'inverter_model':[null, [Validators.required]],
      'battery_storage_capacity':[null, [Validators.required]],
    });

    this.parameters = this.formBuilder.group({
      'kwh': [true],
    });

    this.alertParameter = this.formBuilder.group({
      'kwh': [0],
      'kwhEmail': [false],
      'kwhSMS': [false],
      'kwhFrequency': [1],
      'kwhTime': 'Minutes',
    });

    this.altertNotification = this.formBuilder.group({
      'email1':[null, [Validators.required, Validators.email]],
      'email2': [null, [Validators.email]],
      'email3': [null, [Validators.email]],
      'email4': [null, [Validators.email]],
      'email5': [null, [Validators.email]],
      'phoneNo1': [null, [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo2': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo3': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo4': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      'phoneNo5': [null, [Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]]
    });

    this.dtmuDevice = this.formBuilder.group({
      'device_category':[this.deviceMaster.deviceCategory, [Validators.required]],
      'device_model':[this.deviceMaster.deviceModel, [Validators.required]],
      'device_id': [this.deviceMaster.deviceId, [Validators.required]],
      'heart_beat': ['', [Validators.required]],
      'name': ['', [Validators.required]],
      'passcode': ['', [Validators.required]],
      'remote_controller': false,
    });

    if(this.action.toLowerCase() == 'update'){
      this.solarService.getSolarManagerData({serialNo:this.data.data.serialNo,device_id:this.data.data.device_id}).subscribe(res=>{
        if(res.status){
          this.alertParameter.patchValue(res.alertParameters)
          this.parameters.patchValue(res.parameters)
          this.altertNotification.patchValue(res.alertNotification);
        }
      })

      this.descriptionForm.patchValue(this.data.data);
      this.dtmuDevice.patchValue(this.data.data)
      
    }
  }
  onSubmit(descriptionValues, parametersValues, alertParametersValues, altertNotificationValues, dtmuDeviceValues){
    let formData = {
      action:this.action.toLowerCase(),
      descriptionValues,
      parametersValues,
      alertParametersValues,
      altertNotificationValues,
      dtmuDeviceValues
    }
    this.solarService.addupdateSolarManager(formData).subscribe({
      next: (response) => {
        if (response.status) {
          Swal.fire({
            title: 'Success!',
            text: response.message,
            icon: 'success',
            timer: 1000,
            showConfirmButton: false
          });
          this.matDialogRef.close({update:true});
        } else {
          Swal.fire({
            title: 'Error!',
            text: response.message || 'Unexpected error occurred.',
            icon: 'error',
            timer: 1500,
            showConfirmButton: false
          });
        }
      },
      error: (error) => {
        console.error('HTTP Error:', error);
    
        // Check for specific error status
        let errorMessage = 'Unexpected error occurred.';
        if (error.status === 409) {
          errorMessage = 'A solar manager with this serial number already exists.';
        } else if (error.status === 500) {
          errorMessage = 'Internal server error. Please try again later.';
        }
    
        Swal.fire({
          title: 'Error!',
          text: errorMessage,
          icon: 'error',
          timer: 3000,
          showConfirmButton: false
        });
      }
    });    
  }

}
